export const production = {
  // VUE_APP_API_HOST_ZLZ: 'https://test.fyworkshop.com:8443/gisnanhai' // 测试服 HOST
  VUE_APP_API_HOST_ZLZ: `https://xiaoshan.scanarchi.com/xiaoshangis` // 正式服 HOST
};
